var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginGovLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 42,
    viewBox: "0 0 312 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B51E23",
    d: "M28.43 0H16.52v42c11.3-5 15.25-11.48 16.25-13.5a2.78 2.78 0 0 0 .28-1.24V4.62A4.62 4.62 0 0 0 28.43 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E21D3E",
    d: "M4.62 0A4.62 4.62 0 0 0 0 4.62v22.64c-.004.43.092.854.28 1.24 1 2 5 8.53 16.24 13.5V0H4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.45 18.1a4.69 4.69 0 1 0-5.8 0c-.52 2.94-1.033 5.88-1.54 8.82a26.18 26.18 0 0 0 4.41.38c1.5.03 2.998-.07 4.48-.3-.52-3-1-5.94-1.55-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#112E51",
    d: "M54.25 6.21h-6.66V35.7h19.3v-5.81H54.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#112E51",
    fillRule: "nonzero",
    d: "M87.47 6c-9 0-15.84 6.36-15.84 15s6.82 15 15.84 15 15.84-6.53 15.84-15c0-8.47-6.82-15-15.84-15Zm.08 24.18a9.17 9.17 0 0 1-9.1-9.18 9.07 9.07 0 0 1 9.1-9.15A9 9 0 0 1 96.49 21a9 9 0 0 1-8.94 9.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#112E51",
    d: "M125.74 11.77a12.35 12.35 0 0 1 8.09 3.29l3.75-4.76A18.55 18.55 0 0 0 125.74 6c-9.19 0-16.1 6.45-16.1 15s6.79 15 15.72 15a21.81 21.81 0 0 0 12-3.84V19.48H126.4v5.21h5.15v3.89a13.38 13.38 0 0 1-5.77 1.6 9.21 9.21 0 1 1 0-18.41h-.04Zm21.19-5.56h6.66V35.7h-6.66zm37.29 18.96L169.89 6.21h-6.07V35.7h6.36V16.79l14.29 18.91h6.06V6.21h-6.31zm18.87 3.09a3.66 3.66 0 0 0-3.75 3.85 3.75 3.75 0 1 0 7.49 0 3.63 3.63 0 0 0-3.74-3.85Zm25-16.49a12.35 12.35 0 0 1 8.09 3.29l3.75-4.76A18.55 18.55 0 0 0 228.09 6C218.9 6 212 12.45 212 21s6.79 15 15.72 15a21.81 21.81 0 0 0 12-3.84V19.48h-10.97v5.21h5.15v3.89a13.38 13.38 0 0 1-5.77 1.6 9.21 9.21 0 1 1 0-18.41h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#112E51",
    fillRule: "nonzero",
    d: "M262.9 6c-9 0-15.84 6.36-15.84 15s6.83 15 15.84 15 15.85-6.53 15.85-15c0-8.47-6.83-15-15.85-15Zm.1 24.18a9.17 9.17 0 0 1-9.1-9.22 9.07 9.07 0 0 1 9.1-9.15 9 9 0 0 1 8.92 9.19 9 9 0 0 1-8.92 9.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#112E51",
    d: "m305.13 6.21-8.09 22.25-8.05-22.25h-7.16l11.59 29.49h6.87L312 6.21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGovLogo);
export default __webpack_public_path__ + "static/media/login-gov-logo.707a33a985ccf2ac23f07b0514a1f6e7.svg";
export { ForwardRef as ReactComponent };